import React from 'react';
import get from 'lodash/get';
import { Select } from '@/components/select';
import { Controller } from 'react-hook-form';

// eslint-disable-next-line max-len
const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const fields = {
    firstName: 'info.First Name',
    lastName: 'info.Last Name',
    email: 'info.Email',
    phoneNumber: 'info.Phone number',
    country: 'info.Country',
    city: 'info.City',
};

export const BasicForm = ({ register, control, countries, cities, errors }) => {
    const renderError = field => (
        <React.Fragment>
            {get(errors, field) && (
                <div className="invalid-feedback">{get(errors, `${field}.message`)}</div>
            )}
        </React.Fragment>
    );

    // If we don't have any suggestions for city then display an input for user
    const renderCityInput = () => {
        if (!Array.isArray(cities) || !cities.length) {
            return (
                <input
                    type="text"
                    className="form-control"
                    name={fields.city}
                    ref={register}
                    placeholder="Please specify"
                />
            );
        }

        return (
            <Controller
                helperText="You can add a new city by writing its name and pressing enter"
                as={Select}
                control={control}
                label="City"
                SelectProps={{
                    isCreatable: true,
                    isClearable: false,
                    isMulti: false,
                }}
                name={fields.city}
                fullWidth
                options={cities}
            />
        );
    };

    return (
        <section className="form__section">
            <h3 className="form__section__title">Personal Information</h3>
            <div className="row mb-4">
                <div className="col col-12 col-md-6 mb-4 mb-md-0">
                    <div className="form-field required">
                        <input
                            type="text"
                            className="form-control"
                            name={fields.firstName}
                            placeholder="First Name"
                            ref={register({ required: 'First Name is required' })}
                        />
                        {renderError(fields.firstName)}
                    </div>
                </div>
                <div className="col col-12 col-md-6">
                    <div className="form-field required">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Last Name"
                            name={fields.lastName}
                            ref={register({ required: 'Last Name is required' })}
                        />
                        {renderError(fields.lastName)}
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col">
                    <div className="form-field required">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Email"
                            name={fields.email}
                            ref={register({
                                required: 'Email is required',
                                pattern: {
                                    value: regexEmail,
                                    message: 'Email is invalid',
                                },
                            })}
                        />
                        {renderError(fields.email)}
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col">
                    <div className="form-field required">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Phone number"
                            name={fields.phoneNumber}
                            ref={register({
                                required: 'Phone number is required',
                            })}
                        />
                        {renderError(fields.phoneNumber)}
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col">
                    <div className="form-field">
                        <input
                            type="text"
                            className="form-control"
                            name="info.Organisation"
                            ref={register}
                            placeholder="Organisation (if applicable)"
                        />
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col col-12 col-md-6">
                    <div className="form-field required">
                        <Controller
                            as={Select}
                            control={control}
                            label="Country"
                            SelectProps={{
                                isClearable: true,
                                isMulti: false,
                            }}
                            name={fields.country}
                            fullWidth
                            rules={{
                                required: 'Country is required',
                            }}
                            options={countries}
                        />
                        {renderError(fields.country)}
                    </div>
                </div>
                <div className="col col-12 col-md-6">
                    <div className="form-field">
                        {renderCityInput()}
                        {renderError(fields.city)}
                    </div>
                </div>
            </div>
        </section>
    );
};
